// extracted by mini-css-extract-plugin
export default {"logoContainer":"LogoFooter_logoContainer__Loah6","logo":"LogoFooter_logo__qVlL1"};